import { ChevronUp } from 'lucide-react';

import { cn } from '@/lib/utils';
import type { FilterItem, Tag } from '@/features/fanfiction-filters/types/fanfiction-filters.types';

interface FilterHeaderProps {
  sectionKey: string;
  title: string;
  count?: number;
  items?: FilterItem[];
  activeTags?: Tag[];
  isActive?: boolean;
  sections: Record<string, { isExpanded: boolean }>;
  toggleSection: (key: string) => void;
  hasSelectedItems: (items: FilterItem[]) => boolean;
}

export const FilterHeader = ({
  sectionKey,
  title,
  count,
  items,
  activeTags,
  isActive,
  sections,
  toggleSection,
  hasSelectedItems,
}: FilterHeaderProps) => {
  const hasSelected = items ? hasSelectedItems(items) : activeTags && activeTags.length > 0;
  const shouldShowIndicator = count !== undefined && count > 0;

  return (
    <div
      className="flex justify-between items-center cursor-pointer"
      onClick={() => toggleSection(sectionKey)}
    >
      <div className="flex items-center gap-1">
        <span className="text-sm font-medium text-[#2F323A]">{title}</span>
        {shouldShowIndicator && (
          <div className="min-w-4 px-1 py-0.5 bg-[var(--slate-200)] rounded flex justify-center items-center">
            {hasSelected ? (
              <div className="w-2 h-2 bg-[var(--brand-blue)] rounded-full" />
            ) : (
              <span className="text-xs font-medium text-[var(--slate-600)]">{count}</span>
            )}
          </div>
        )}
        {isActive && (
          <div className="bg-[#505CFF] w-2.5 h-2.5 rounded-full border-white border-[1px]" />
        )}
      </div>
      <div className="w-4 h-4 flex items-center justify-center">
        <ChevronUp
          className={cn(
            `text-[#c0c3d3] w-full h-full`,
            sections[sectionKey]?.isExpanded ? 'rotate-180' : '',
          )}
        />
      </div>
    </div>
  );
};
